import React, { useState } from "react";
import { http } from "@/lib/api";
import { useAuth } from "@/App";
import { toast } from "sonner";

const PACKS = [
  { id: "credits100", label: "Credit pack", price: "$9", note: "100 credits, never expire", cta: "Buy 100 credits" },
  { id: "pro", label: "Pro", price: "$19", note: "500 listings / month", cta: "Go Pro", highlight: true },
  { id: "studio", label: "Studio", price: "$39", note: "5,000 listings / month", cta: "Go Studio" },
];

const PLAN_LABEL = { pro: "Pro", studio: "Studio" };

export default function CreditsPanel() {
  const { user } = useAuth();
  const [loading, setLoading] = useState("");

  const checkout = async (pkg) => {
    setLoading(pkg);
    try {
      const r = await http.post("/credits/checkout", { package: pkg, origin_url: window.location.origin });
      if (r.data?.url) window.location.href = r.data.url;
    } catch (e) { toast.error(e?.response?.data?.detail || "Checkout failed"); }
    finally { setLoading(""); }
  };

  return (
    <div className="space-y-5">
      <div className="tt-card p-6">
        <h1 className="text-3xl font-black h-tight">Credits</h1>
        <div className="mt-2 text-sm text-zinc-500">
          {PLAN_LABEL[user?.plan] && (
            <span className="mr-3">
              Plan: <span className="font-bold text-zinc-900">{PLAN_LABEL[user.plan]}</span>
              {typeof user?.quota_left === "number" && (
                <span className="mono"> · {user.quota_left} left this month</span>
              )}
            </span>
          )}
          Credits:{" "}
          <span className="mono font-bold text-zinc-900" data-testid="credits-balance">{user?.credits ?? 0}</span>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-5">
        {PACKS.map(p => (
          <div key={p.id} className={"tt-card p-6 flex flex-col " + (p.highlight ? "border-2 border-[#09090B]" : "")}>
            <div className="text-sm font-bold uppercase tracking-widest text-zinc-500">{p.label}</div>
            <div className="mt-2 text-5xl font-black h-tight">{p.price}</div>
            <div className="text-sm text-zinc-500">{p.note}</div>
            <button
              data-testid={`buy-${p.id}`}
              disabled={loading === p.id}
              onClick={() => checkout(p.id)}
              className={"mt-6 " + (p.highlight ? "btn-primary" : "btn-dark") + " w-full"}
            >{loading === p.id ? "Redirecting…" : p.cta}</button>
          </div>
        ))}
      </div>
    </div>
  );
}
